import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sha256 } from 'js-sha256';
import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
const TRACKING_ID = 'GTM-KZCTBJQC';
const GlobalDataLayer = ({ merchant_id, email, children }) => {
    const hashedEmail = sha256(email.toLowerCase());
    return (_jsxs(ReactHelmet, { children: [_jsx("script", { children: `
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments);
            }
            gtag('consent', 'default', {
              'ad_storage': 'denied',
              'analytics_storage': 'denied',
              'region': ['CA-QC']
            });
            gtag('set', 'ads_data_redaction', true);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "hashed_email": "${hashedEmail}",
              "merchant_id": "${merchant_id}"
            });

            (function(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({
                  'gtm.start': new Date().getTime(),
                  event: 'gtm.js'
              });
              var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l != 'dataLayer' ? '&l=' + l : '';
              j.async = true;
              j.src =
                  'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
              f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', "${TRACKING_ID}");

          ` }), children] }));
};
export default GlobalDataLayer;
